import Vue from 'vue'
import type VueRouter from 'vue-router'

export async function setupRaygun(router: VueRouter, apiKey: string) {
  const { default: raygun } = await import('raygun4js')

  raygun('apiKey', apiKey)
  Vue.config.errorHandler = (error) => {
    raygun('send', {
      error,
    })
  }
  raygun('enableCrashReporting', true)
  raygun('enablePulse', true)
  router.afterEach((to) => {
    raygun('trackEvent', {
      type: 'pageView',
      path: to.path,
    })
  })
}
